import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import router from './router';
import { store } from '@/store';
import getPageTitle from '@/utils/page';
var asyncRouterFlag = 0;
var whiteList = ['Login', 'Init'];
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var token, asyncRouters;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          token = store.getters['user/token']; // 在白名单中的判断情况
          // 修改网页标签名称
          document.title = getPageTitle(to.meta.title);
          if (!(whiteList.indexOf(to.name) > -1)) {
            _context.next = 1;
            break;
          }
          if (token) {
            next({
              name: store.getters['user/userInfo'].authority.defaultRouter
            });
          } else {
            next();
          }
          _context.next = 6;
          break;
        case 1:
          if (!token) {
            _context.next = 5;
            break;
          }
          if (!(!asyncRouterFlag && store.getters['router/asyncRouters'].length === 0)) {
            _context.next = 4;
            break;
          }
          asyncRouterFlag++;
          _context.next = 2;
          return store.dispatch('router/SetAsyncRouter');
        case 2:
          _context.next = 3;
          return store.dispatch('user/GetUserInfo');
        case 3:
          asyncRouters = store.getters['router/asyncRouters'];
          router.addRoutes(asyncRouters);
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.next = 5;
          break;
        case 4:
          if (to.matched.length) {
            next();
          } else {
            next({
              path: '/layout/404'
            });
          }
        case 5:
          // 不在白名单中并且未登陆的时候
          if (!token) {
            next({
              name: 'Login',
              query: {
                redirect: document.location.hash
              }
            });
          }
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());